import { render, staticRenderFns } from "./Watchmen.vue?vue&type=template&id=1919e0c8"
import script from "./Watchmen.vue?vue&type=script&lang=js"
export * from "./Watchmen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports